import React, { useState,useEffect } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  FormControl,
  IconButton,
  FormLabel,
  FormHelperText,
  Autocomplete,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import dayjs from "dayjs"; 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { createCustomer } from '../../redux/Slice/customerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/Slice/loaderSlice';
import { useNavigate } from 'react-router-dom';
import { Country, State, City } from "country-state-city";
import { getCountryCallingCode } from "libphonenumber-js";
import { toast } from 'sonner';
import { clearMessage } from '../../redux/Slice/message';



function CustomerCreation() {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const message = useSelector((state) => state.message);

  const [contactPerson, setContactPersons] = useState([
    { name: '', designation: '', email: '', country_code:'', phoneNumber: '', linkedinUrl: '' },
  ]);
   
  const [domain,setDomain]=useState(null)

  const [follow_up_history, setFollowUpHistory] = useState();

  const [other_urls, setOtherURL] = useState();

  const validationSchema = Yup.object({
    companyName: Yup.string().required('Company Name is required'),
    industry: Yup.string().required('Industry is required'),
    website: Yup.string().required('Website is required').url('Invalid URL format'),
    company_email: Yup.string().required('Company Email is required').email('Invalid Email Address'),
    location: Yup.object({
      city: Yup.string(),
      state: Yup.string(),
      country: Yup.string().required('Country is required'),
      address: Yup.string().required('Address is required'),
      pincode: Yup.string().required('Pincode is required'),
    }),
    contactPerson: Yup.array().of(
      Yup.object({
        name: Yup.string().required('Contact Name is required'),
        designation: Yup.string(),
        email: Yup.string().email('Invalid Email Address').required('Email is required'),
        country_code: Yup.string(),
        phoneNumber: Yup.string().matches(/^\d*$/, "Phone number must contain only digits"),
        linkedinUrl: Yup.string().url('Invalid LinkedIn URL'),
      })
    ),
    other_urls: Yup.array().of(
      Yup.object({
        field: Yup.string().required('Field is required'),
        value: Yup.string().required('Value is required').url('Invalid URL'),
      })
    ),
  });

  const formik = useFormik({
    initialValues: {
      companyName: '',
      customer_type:'New Customer',
      company_email:'',
      contactPerson,
      industry: '',
      website:'',
      location: { city: '', state: '', country: '', address:'', pincode:'' },
      other_urls:[],
      lead_Conversion_details:{ lead_id: null, conversion_date:'', converted_by:'', conversion_notes:''},
      current_assignment_employee_id: null,
      previous_assignment_employee_ids:[],
      follow_up_history,
      demo_schedule:[],
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(setLoading(true));
      dispatch(createCustomer({...values}))
                .then(() => {
                  dispatch(setLoading(false));
                  formik.resetForm();
                  navigate(-1);
                })
                .catch(() => {
                  dispatch(setLoading(false));
                });
  }});


  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  
  const countries = Country.getAllCountries();
  const states = selectedCountry ? State.getStatesOfCountry(countries.find(c => c.name === selectedCountry)?.isoCode) : [];
  const cities = selectedState ? City.getCitiesOfState(countries.find(c => c.name === selectedCountry)?.isoCode, states.find(s => s.name === selectedState)?.isoCode) : [];

  useEffect(() => {
    if (selectedCountry) {
      const isoCode = countries.find((c) => c.name === selectedCountry)?.isoCode;
      if (isoCode) {
        const newCountryCode = `+${getCountryCallingCode(isoCode) || ""}`;

        formik.setFieldValue(
          "contactPerson",
          formik.values.contactPerson.map((contact) => ({
            ...contact,
            country_code: newCountryCode,
          }))
        );
      }
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleAddContactPerson = () => {
    const isoCode = countries.find((c) => c.name === selectedCountry)?.isoCode;
    const countryCode = isoCode ? `+${getCountryCallingCode(isoCode) || ""}` : "";

    formik.setFieldValue("contactPerson", [
      ...formik.values.contactPerson,
      { name: "", designation: "", email: "", country_code: countryCode, phoneNumber: "", linkedinUrl: "" },
    ]);
  };
 
 
  // const handleAddContactPerson = () => {
  //   formik.setFieldValue('contactPerson', [
  //     ...formik.values.contactPerson,
  //     { name: '', designation: '', email: '',country_code:'',phoneNumber: '', linkedinUrl: '' },
  //   ]);
  // };


  const handleRemoveContactPerson = (index) => {
    const updatedContacts = [...formik.values.contactPerson];
    updatedContacts.splice(index, 1);
    formik.setFieldValue('contactPerson', updatedContacts);
  };

  const handleAddURL = () => {
    formik.setFieldValue('other_urls', [
      ...formik.values.other_urls,
      { field: '', value: ''}, 
    ]);
  };

  const handleRemoveURL = (index) => {
    const updatedUrl = [...formik.values.other_urls];
    updatedUrl.splice(index, 1);
    formik.setFieldValue('other_urls', updatedUrl);
  };

  const handleReset = () => {
    formik.resetForm();
  };


 
  



  return (
    <Box container>
      <Typography variant="h4" gutterBottom>
        New Customer
      </Typography>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
        <Box
          sx={{
            mt: 1
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container 
            spacing={2}
            sx={{ p: 3, border: "1px solid #ddd", borderRadius: 2 }}
            >

              {/* Company Name */}
              <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel>Company Name <span style={{ color: "red" }}>*</span></FormLabel>
                  <TextField
                    name="companyName"
                    placeholder="Company Name"
                    variant="outlined"
                    value={formik.values.companyName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                    helperText={formik.touched.companyName && formik.errors.companyName}
                  />
                </FormControl>
              </Grid>

              {/* Industry */}
              <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel>Industry <span style={{ color: "red" }}>*</span></FormLabel>
                  <Select
                    name="industry"
                    value={formik.values.industry}
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>Select Industry</MenuItem>
                    <MenuItem value="Construction">Construction</MenuItem>
                    <MenuItem value="IT">IT</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                    <MenuItem value="Healthcare">Healthcare</MenuItem>
                    <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {formik.touched.industry && formik.errors.industry && (
    <FormHelperText error={formik.touched.industry && Boolean(formik.errors.industry)}>{formik.errors.industry}</FormHelperText>
  )}
                </FormControl>
              </Grid>

              {/* Website */}
              <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel>Website <span style={{ color: "red" }}>*</span></FormLabel>
                  <TextField
                    name="website"
                    value={formik.values.website}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.website && Boolean(formik.errors.website)}
                    helperText={formik.touched.website && formik.errors.website}
                    placeholder="Website"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>

                {/* Company Email */}
                <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel htmlFor='company_email *'>Company Email <span style={{ color: "red" }}>*</span></FormLabel>
                  <TextField
                    name="company_email"
                    value={formik.values.company_email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.company_email && Boolean(formik.errors.company_email)}
                    helperText={formik.touched.company_email && formik.errors.company_email}
                    placeholder="Email Address"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>

              {/* Country */}
              <Grid item size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth>
                  <FormLabel>Country <span style={{ color: "red" }}>*</span></FormLabel>
                  <Autocomplete
                    options={countries}
                    getOptionLabel={(country) => country.name}
                    value={countries.find(c => c.name === selectedCountry) || null}
                    onChange={(e, newValue) => {
                      const countryName = newValue ? newValue.name : "";
                      setSelectedCountry(countryName);
                      setSelectedState(""); 
                      formik.setFieldValue("location.state", "");
                      formik.setFieldValue("location.city", "");
                      formik.setFieldValue("location.country", countryName); 
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Country"
                        name="location.country"
                        size="small"
                        onBlur={formik.handleBlur}
                        error={formik.touched.location?.country && Boolean(formik.errors.location?.country)}
                        helperText={formik.touched.location?.country && formik.errors.location?.country}
                      />
                    )}
              
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        border: "none", 
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        border: "none", 
                      },
                    }}
                  />
                </FormControl>
              </Grid>  

              {/* State */}
              <Grid item size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth>
                  <FormLabel>State</FormLabel>
                  <Autocomplete
                    options={states}
                    getOptionLabel={(state) => state.name}
                    value={states.find(s => s.name === selectedState) || null}
                    onChange={(e, newValue) => {
                      const stateName = newValue ? newValue.name : "";
                      setSelectedState(stateName); 
                      formik.setFieldValue("location.city", ""); 
                      formik.setFieldValue("location.state", stateName); 
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select State"
                        name="location.state"
                        size="small"
                        onBlur={formik.handleBlur}
                        disabled={!selectedCountry} 
                        error={formik.touched.location?.state && Boolean(formik.errors.location?.state)}
                        helperText={formik.touched.location?.state && formik.errors.location?.state}
                      />
                    )}
              
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        border: "none", 
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        border: "none", 
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              
              {/* City */}
              <Grid item size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth>
                  <FormLabel>City</FormLabel>
                  <Autocomplete
                    options={cities}
                    getOptionLabel={(city) => city.name}
                    value={cities.find(c => c.name === formik.values.location?.city) || null}
                    onChange={(e, newValue) => {
                      const cityName = newValue ? newValue.name : "";
                      formik.setFieldValue("location.city", cityName); 
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select City"
                        name="location.city"
                         size="small"
                        onBlur={formik.handleBlur}
                        disabled={!selectedState}
                        error={formik.touched.location?.city && Boolean(formik.errors.location?.city)}
                        helperText={formik.touched.location?.city && formik.errors.location?.city}
                      />
                    )}
              
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        border: "none", 
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        border: "none", 
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              {/* Address */}
              <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel htmlFor='location.address'>Address <span style={{ color: "red" }}>*</span></FormLabel>
                  <TextField
                    name="location.address"
                    value={formik.values.location?.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.location && formik.touched.location?.address && Boolean(formik.errors.location?.address)}
                    helperText={formik.touched.location && formik.touched.location?.address && formik.errors.location?.address}
                    placeholder="Address"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>

               {/* Pincode */}
               <Grid item size={{xs:12, md:4}}>
                <FormControl fullWidth>
                  <FormLabel htmlFor='location.pincode'>Pincode</FormLabel>
                  <TextField
                    name="location.pincode"
                    value={formik.values.location?.pincode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.location && formik.touched.location?.pincode && Boolean(formik.errors.location?.pincode)}
                    helperText={formik.touched.location && formik.touched.location?.pincode && formik.errors.location?.pincode}
                    placeholder="Pincode"
                    variant="outlined"
                    type="number"
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                   '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
                     WebkitAppearance: 'none',
                     margin: 0,
                   },
                   '& input[type="number"]': {
                     MozAppearance: 'textfield', // For Firefox
                   },
                  }}
                  />
                </FormControl>
              </Grid>

              {/* Contact Persons */}
              <Grid item size={{xs:12, md: 12}}>
                <Typography variant="h6" marginBottom={1}>Contact Persons</Typography>
                {formik.values.contactPerson.map((contact, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                    <TextField
                      placeholder="Name"
                      variant="outlined"
                      fullWidth
                      name={`contactPerson[${index}].name`}
                      value={contact.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.name &&
                        Boolean(formik.errors.contactPerson?.[index]?.name)
                      }
                      helperText={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.name &&
                        formik.errors.contactPerson?.[index]?.name
                      }
                    />
                    <TextField
                      placeholder="Designation"
                      variant="outlined"
                      fullWidth
                      name={`contactPerson[${index}].designation`}
                      value={contact.designation}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <TextField
                      placeholder="Email"
                      variant="outlined"
                      fullWidth
                      name={`contactPerson[${index}].email`}
                      value={contact.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.email &&
                        Boolean(formik.errors.contactPerson?.[index]?.email)
                      }
                      helperText={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.email &&
                        formik.errors.contactPerson?.[index]?.email
                      }
                      type="email"
                    />
                    <TextField
                      placeholder="Phone Number"
                      variant="outlined"
                      fullWidth
                      name={`contactPerson[${index}].phoneNumber`}
                      value={contact.phoneNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.phoneNumber &&
                        Boolean(formik.errors.contactPerson?.[index]?.phoneNumber)
                      }
                      helperText={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.phoneNumber &&
                        formik.errors.contactPerson?.[index]?.phoneNumber
                      }
                      type="number"
                      onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 10);
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      MozAppearance: 'textfield', // For Firefox
    },
  }}
                    />
                    <TextField
                      name={`contactPerson[${index}].linkedinUrl`}
                      value={contact.linkedinUrl}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="LinkedIn"
                      variant="outlined"
                      fullWidth
                      error={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.linkedinUrl &&
                        Boolean(formik.errors.contactPerson?.[index]?.linkedinUrl)
                      }
                      helperText={
                        formik.touched.contactPerson &&
                        formik.touched.contactPerson[index]?.linkedinUrl &&
                        formik.errors.contactPerson?.[index]?.linkedinUrl
                      }
                    />
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveContactPerson(index)}
                      sx={{ alignSelf: 'center' }}
                    >
                      <RemoveCircle />
                    </IconButton>
                  </Box>
                ))}
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<AddCircle />}
                  onClick={handleAddContactPerson}
                >
                  Add Another Contact
                </Button>
              </Grid>

              {/* FolloW Ups */}
              {/* <Grid item size={{xs:12, md: 12}}>
                <Typography variant="h6" marginBottom={1}>Next Follow-Up</Typography>
                {formik.values.follow_up_history.map((followup, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 2 }}>

                   <FormControl fullWidth>
                   <FormLabel>Follow-Up Type</FormLabel>
  <Select
    name={`follow_up_history[${index}].follow_up_type`}
    value={followup.follow_up_type}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    displayEmpty
  >
    <MenuItem value="" disabled>
      Follow-up Type
    </MenuItem>
    <MenuItem value="Email">Email</MenuItem>
    <MenuItem value="Call">Call</MenuItem>
    <MenuItem value="Meeting">Meeting</MenuItem>
  </Select>
  {formik.touched.follow_up_history &&
    formik.touched.follow_up_history[index]?.follow_up_type && (
      <FormHelperText error={Boolean(formik.errors.follow_up_history?.[index]?.follow_up_type)}>
        {formik.errors.follow_up_history?.[index]?.follow_up_type}
      </FormHelperText>
    )}
</FormControl>
<FormControl fullWidth>
<FormLabel>Follow-Up Subject</FormLabel>
<TextField
                      placeholder="Follow-Up Subject"
                      variant="outlined"
                      fullWidth
                      name={`follow_up_history[${index}].follow_up_subject`}
                      value={followup.follow_up_subject}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.follow_up_history &&
                        formik.touched.follow_up_history[index]?.follow_up_subject &&
                        Boolean(formik.errors.follow_up_history?.[index]?.follow_up_subject)
                      }
                      helperText={
                        formik.touched.follow_up_history &&
                        formik.touched.follow_up_history[index]?.follow_up_subject &&
                        formik.errors.follow_up_history?.[index]?.follow_up_subject
                      }
                    />
</FormControl>
<FormControl fullWidth>
<FormLabel>Follow-Up Notes</FormLabel>
<TextField
                      placeholder="Follow-Up Notes"
                      variant="outlined"
                      fullWidth
                      name={`follow_up_history[${index}].follow_up_notes`}
                      value={followup.follow_up_notes}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.follow_up_history &&
                        formik.touched.follow_up_history[index]?.follow_up_notes &&
                        Boolean(formik.errors.follow_up_history?.[index]?.follow_up_notes)
                      }
                      helperText={
                        formik.touched.follow_up_history &&
                        formik.touched.follow_up_history[index]?.follow_up_notes &&
                        formik.errors.follow_up_history?.[index]?.follow_up_notes
                      }
                    />
</FormControl>

                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                     <FormControl fullWidth>
                     <FormLabel>Follow-Up Date</FormLabel>
  <MobileDateTimePicker
    // defaultValue={dayjs()}
    format="LLL"
    value={formik.values.follow_up_history?.[index]?.next_followUp_date || null}
    onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue(`follow_up_history[${index}].next_followUp_date`, formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError(`follow_up_history[${index}].next_followUp_date`, "Invalid date");
      }
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        fullWidth
        placeholder="Follow-Up Date"
        error={
          formik.touched.follow_up_history &&
          formik.touched.follow_up_history[index]?.next_followUp_date &&
          Boolean(formik.errors.follow_up_history?.[index]?.next_followUp_date)
        }
        helperText={
          formik.touched.follow_up_history &&
          formik.touched.follow_up_history[index]?.next_followUp_date &&
          formik.errors.follow_up_history?.[index]?.next_followUp_date
        }
      />
    )}
  />
</FormControl>
                    </LocalizationProvider>

                  </Box>
                ))}
              </Grid> */}

                            {/* Other URLs */}
                            <Grid item size={{xs:12, md: 12}}>
                <Typography variant="h6" marginBottom={1}>Other URLs</Typography>
                {formik.values.other_urls?.map((url, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                    <TextField
                      placeholder="Field Name"
                      variant="outlined"
                      fullWidth
                      name={`other_urls[${index}].field`}
                      value={url.field}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.other_urls &&
                        formik.touched.other_urls[index]?.field &&
                        Boolean(formik.errors.other_urls?.[index]?.field)
                      }
                      helperText={
                        formik.touched.other_urls &&
                        formik.touched.other_urls[index]?.field &&
                        formik.errors.other_urls?.[index]?.field
                      }
                    />
                    <TextField
                      placeholder="Value"
                      variant="outlined"
                      fullWidth
                      name={`other_urls[${index}].value`}
                      value={url.value}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.other_urls &&
                        formik.touched.other_urls[index]?.value &&
                        Boolean(formik.errors.other_urls?.[index]?.value)
                      }
                      helperText={
                        formik.touched.other_urls &&
                        formik.touched.other_urls[index]?.value &&
                        formik.errors.other_urls?.[index]?.value
                      }
                    />
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveURL(index)}
                      sx={{ alignSelf: 'center' }}
                    >
                      <RemoveCircle />
                    </IconButton>
                  </Box>
                ))}
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<AddCircle />}
                  onClick={handleAddURL}
                >
                  Add URL
                </Button>
              </Grid>
            </Grid>
            <Grid
          sx={{ justifyContent: "flex-end", display: "flex", gap: 3, mt: 3 }}
        >
          <Button variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <Button type="submit" variant="contained">
            Submit
          </Button>
        </Grid>
          </form>
        </Box>
      </Box>
    </Box>
  );
}

export default CustomerCreation;

